'use strict';

const processInclude = require('base/util');

$(window).on('load', function () {
    processInclude(require('./ga4/analyticsGA4'));
    processInclude(require('./ga4/checkoutEvents'));
});
